import { RadioButtonGroup } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ROOM_TYPES } from './constants';
import { changeRooms } from '../../../actions/rooms';
import { FormField } from '../../../components/FormField';
import { selectRooms } from '../../../selectors/rooms';
import { TThunkDispatch } from '../../../types/redux/thunk';
import { ERooms } from '../../../types/rooms';

export const Rooms: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const rooms = useSelector(selectRooms);

  const handleChangeRooms = (e: React.ChangeEvent<HTMLInputElement>, value: ERooms) => {
    dispatch(changeRooms(value));
  };

  return (
    <FormField label="Сколько комнат?" data-name="RoomsFormField">
      <RadioButtonGroup options={ROOM_TYPES} spliced={false} value={rooms} onChange={handleChangeRooms} />
    </FormField>
  );
};
